let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kthj9")).then(() => parcelRequire('eqkO8'));